<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scope></style>

<script>
  import { isMobile } from 'mobile-device-detect'

  export default {
    name: 'BackToTopButton',
    data: () => ({
      isMobile: isMobile,
      showButton: false,
    }),
    watch: {
      '$route.name'() {
        this.toggleButton()
      },
    },
    created() {
      window.addEventListener('resize', this.toggleButton)
    },
    destroyed() {
      window.removeEventListener('resize', this.toggleButton)
    },
    methods: {
      toggleButton() {
        if (typeof window === 'undefined') return
        // 104 is the height of the div for the scroll-fab
        let bodySize = document.body.offsetHeight
        bodySize -= this.showButton ? 104 : 0
        this.showButton = bodySize > window.innerHeight
      },
      toTop() {
        this.$vuetify.goTo(0)
      },
    },
  }
</script>
